import { Directive, Input, TemplateRef } from '@angular/core';
import { PhxCellBase } from './phx-cell-base';

/** Captures a cell template keyed by column ID; the row stamps it into `<td phx-table-cell>`. */
@Directive({ selector: '[phxCellDef]' })
export class PhxCellDefDirective extends PhxCellBase {
  /** Column key this template renders. Must match a `key` in `phxColumnsConfig`. */
  @Input('phxCellDef') columnId!: string;

  /** When true, omits this cell so a `phxRowspan` cell in an earlier row can cover it. */
  @Input() phxSkip: boolean = false;

  constructor(public templateRef: TemplateRef<void>) {
    super();
  }
}
